import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Email from "@material-ui/icons/Email";
import Phone from "@material-ui/icons/Phone";
import LocationOn from "@material-ui/icons/LocationOn";
import { useSelector } from "react-redux";
import { Main } from "src/components/commons/Main";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

export function ContactUs() {
	const { tenant } = useSelector(({ auth }) => auth);
	const phone = tenant?.contact_phone || "+1 541-903-5090";
	const email = tenant?.contact_email || "info@investormatch.ai";
	const address = tenant?.contact_Address || "InvestorMatch.ai LLC 6455 NW Concord Drive, Corvallis, Oregon 97330";
	//const address2 = tenant?.contactAddress2 || "InvestorMatch.ai LLC 6455 NW Concord Drive, Corvallis, Oregon 97330";
	const faqs = [
		{
			question: "How do I get started with InvestorMatch?",
			answer: "Simply sign up on our platform, complete your profile, and start connecting with partners tailored to your needs."
		},
		{
			question: "Is there a cost to use InvestorMatch?",
			answer: "Basic access is free. Premium features may require a subscription. Contact us for more details."
		},
		{
			question: "How do I contact support?",
			answer: "You can reach our support team via the contact form, email, or phone listed above."
		},
	];
	return (
		<Main>
			<Box
				textAlign={"left"}
				height="100%"
				display="flex"
				flexDirection={"column"}
				alignItems="center"
				justifyContent={"center"}
				fontSize={15}
			>
				<div style={{ textAlign: "left", padding: "20px" }}>
				<Typography component="h2" variant="h5" align="left" style={{ fontWeight: "bold", marginBottom: 8 }}>
					Let's work together
				</Typography>
				<Typography component="p" variant="body1" align="left" style={{ marginBottom: 24, borderBottom: "1px solid #e5e7eb" }}>
				By scheduling a conversation we can evaluate and discuss the best approaches to successfully address ways to provide ideal solutions.
				</Typography>
				<div className="grid grid-cols-3 gap-4 mx-8 mb-8">
					<div className="flex flex-col border border-gray-300 rounded-lg p-4 items-start">
						<Typography variant="subtitle1" style={{ fontWeight: "bold", textAlign: "left", width: "100%" }}>Address</Typography>
						<div className="flex items-center mt-2">
							<LocationOn fontSize="large" color="primary" />
							<span style={{ marginLeft: 8 }}>{address}</span>
						</div>
					</div>
					<div className="flex flex-col border border-gray-300 rounded-lg p-4 items-start">
						<Typography variant="subtitle1" style={{ fontWeight: "bold", textAlign: "left", width: "100%" }}>Phone</Typography>
						<div className="flex items-center mt-2">
							<Phone fontSize="large" color="primary" />
							<a href={`tel:${phone}`} style={{ marginLeft: 8, color: "inherit", textDecoration: "none" }}>{phone}</a>
						</div>
					</div>
					<div className="flex flex-col border border-gray-300 rounded-lg p-4 items-start">
						<Typography variant="subtitle1" style={{ fontWeight: "bold", textAlign: "left", width: "100%" }}>Email</Typography>
						<div className="flex items-center mt-2">
							<Email fontSize="large" color="primary" />
							<a href={`mailto:${email}`} style={{ marginLeft: 8, color: "inherit", textDecoration: "none" }}>{email}</a>
						</div>
					</div>
				</div>
				</div>

				{/* FAQ Section */}
				<div className="w-full max-w-3xl mx-auto mt-8 mb-8">
					<Typography component="h2" variant="h5" style={{ fontWeight: "bold", marginBottom: 8 }}>
						FAQ's
					</Typography>
					<Typography component="p" variant="body1" style={{ marginBottom: 24 }}>
					Your Questions, Answered - Explore how InvestorMatch.ai connects founders with the right funders, streamlining your journey to secure funding.
					</Typography>
					{faqs.map((faq, idx) => (
						<Accordion key={idx}>
							<AccordionSummary expandIcon={<ExpandMoreIcon />}>
								<Typography variant="subtitle1" style={{ fontWeight: "bold" }}>{faq.question}</Typography>
							</AccordionSummary>
							<AccordionDetails>
								<Typography variant="body2">{faq.answer}</Typography>
							</AccordionDetails>
						</Accordion>
					))}
				</div>

				{/* <img src={(tenant.logo || {})["2x"]?.path || "/images/logo-v1.png"} alt="logo" width={150} />
				<Typography
					component={"h1"}
					variant={"h4"}
					style={{ marginBottom: "1rem", marginTop: "1rem", textDecoration: "underline" }}
				>
					Contact Us
				</Typography>
				<Box marginBottom={4}>
					<Typography component={"h2"} variant={"h5"} style={{ marginBottom: "0.5rem" }}>
						<Phone fontSize="small" /> Call Us
					</Typography>
					<a href={`tel:${phone}`}>{phone}</a>
				</Box>

				<Typography component={"h2"} variant={"h5"}>
					<Email fontSize="small" /> Email Us
				</Typography>
				<a href={`mailto:${email}`}>{email}</a> */}
			</Box>
		</Main>
	);
}
